import { useEffect, useState } from 'react'

import { useChat } from './ChatContext'
import useIsMounted from '../../useIsMounted'
import { useDebounce } from '../../useDebounce'

export const useAllUnreadMessagesCount = (): number => {
	const { allSubscribedChannel } = useChat()
	const isMounted = useIsMounted()
	const [numberOfUnreadMessages, setNumberOfUnreadMessages] =
		useState<number>(0)

	const debouncedSubscribedChannel = useDebounce(allSubscribedChannel)

	useEffect(() => {
		const getUnreadCount = (): void => {
			const promises = Object.values(debouncedSubscribedChannel).map(ch =>
				ch.getUnreadMessagesCount()
			)

			Promise.all(promises).then(numsOfUnreadMessages => {
				let sumOfUnreadMessages = 0

				for (const num of numsOfUnreadMessages) {
					if (!num) continue

					sumOfUnreadMessages += num
				}

				isMounted() && setNumberOfUnreadMessages(sumOfUnreadMessages)
			})
		}

		getUnreadCount()
	}, [debouncedSubscribedChannel])

	return numberOfUnreadMessages
}
